export const FETCH_FAV_PAGES_SUCCESS = 'fetchFavPagesSuccess';
export const UPDATE_ACTIVE_SORT_FIELD_FAV_PAGES_M = 'updateActiveSortFieldFavPagesMutation';
export const UPDATE_SEARCH_FAV_PAGES_M = 'updateSearchFavPagesMutation';
export const CLEAR_SEARCH_FAV_PAGES_M = 'clearSearchFavPagesMutation';
